import Image from "@tiptap/extension-image";

export default Image.extend({
    name: "customImage",

    addAttributes() {
        return {
            ...this.parent?.(),
            alignment: {
                default: "center",
                parseHTML: (element) => {
                    const float = (element as HTMLElement).style.float;
                    if (float === "left") return "left";
                    if (float === "right") return "right";
                    // assume center if block + auto margins
                    const style = (element as HTMLElement).style;
                    if (style.display === "block" && style.margin === "0 auto")
                        return "center";
                    return "center";
                },
                renderHTML: (attributes) => {
                    switch (attributes.alignment) {
                        case "left":
                            return {
                                style: "float: left; margin-right: 1rem;",
                            };
                        case "right":
                            return {
                                style: "float: right; margin-left: 1rem;",
                            };
                        case "center":
                        default:
                            return {
                                style: "display: block; margin: 0 auto;",
                            };
                    }
                },
            },
        };
    },
});
